export const TRANSACTION_TYPES = {
    CREDIT_SALE: 1,
    NOTIFICATION_PAYMENT_BY_WALLET: 5,
    PARKING_ACTIVATION_WALLET: 6,
    CREDIT_TRANSFER: 8,
    NOTIFICATION_PAYMENT_BY_PAYMENT: 17,
    PARKING_ACTIVATION_AUTOMATIC: 20,
};
